import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '../config/api';

const API = BACKEND_URL;

/**
 * OnlineStatus Component
 * Shows online/offline indicator and "last seen" for users
 * 
 * Usage:
 * <OnlineStatus userId="abc-123" showLabel={true} />
 */
const OnlineStatus = ({ userId, showLabel = false, size = 'sm' }) => {
  const [status, setStatus] = useState({
    is_online: false,
    last_seen: null
  });

  useEffect(() => {
    if (!userId) return;

    fetchStatus();
    
    // Refresh status every 3 minutes
    const interval = setInterval(fetchStatus, 180000);
    
    return () => clearInterval(interval);
  }, [userId]);

  const fetchStatus = async () => {
    try {
      const response = await axios.get(`${API}/api/users/${userId}/status`);
      setStatus(response.data);
    } catch (error) {
      // Silent fail
      console.debug('Failed to fetch user status:', error);
    }
  };

  const getDotSize = () => {
    switch(size) {
      case 'xs': return '6px';
      case 'sm': return '8px';
      case 'md': return '10px';
      case 'lg': return '12px';
      default: return '8px';
    }
  };

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px'
    }}>
      <span style={{
        width: getDotSize(),
        height: getDotSize(),
        borderRadius: '50%',
        backgroundColor: status.is_online ? '#047857' : '#9ca3af',
        display: 'inline-block',
        border: '2px solid white',
        boxShadow: '0 0 0 1px rgba(0,0,0,0.1)'
      }} />
      
      {showLabel && (
        <span style={{
          fontSize: '14px',
          color: status.is_online ? '#047857' : '#6b7280',
          fontWeight: 500
        }}>
          {status.last_seen || (status.is_online ? 'Online' : 'Offline')}
        </span>
      )}
    </div>
  );
};

export default OnlineStatus;
